import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { TopicWrapper } from '../pages/topics/TopicWrapper'
import { ExamWrapper } from '../pages/exams/ExamWrapper'
import { ResultWrapper } from '../pages/results/ResultWrapper'
import { UserWrapper } from '../pages/users/UserWrapper'


import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { DisableSidebar } from '../../_metronic/layout/core'
import { TrainerWrapper } from '../pages/trainers/TrainerWrapper'
import { StudentWrapper } from '../pages/students/StudentWrapper'
import { ScheduleWrapper } from '../pages/schedules/ScheduleWrapper'
import { ReportWrapper } from '../pages/reports/ReportWrapper'
import { MissionWrapper } from '../pages/missions/MissionWrapper'
import { CompanyWrapper } from '../pages/companies/CompanyWrapper'

const PrivateRoutes = () => {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='topic/*' element={<SuspensedView><TopicWrapper /></SuspensedView>} />
        <Route path='mission/*' element={<SuspensedView><MissionWrapper /></SuspensedView>} />
        <Route path='exam/results' element={<SuspensedView><ResultWrapper /></SuspensedView>} />
        <Route path='exam/*' element={<SuspensedView><ExamWrapper /></SuspensedView>} />
        <Route path='users/:id' element={<SuspensedView><UserWrapper /></SuspensedView>} />
        <Route path='sections/*' element={<SuspensedView><CompanyWrapper /></SuspensedView>} />
        <Route path='account/users/:id*' element={<SuspensedView><AccountPage /></SuspensedView>} />

        <Route path='schedule/list' element={<SuspensedView><ScheduleWrapper></ScheduleWrapper></SuspensedView>} />
        <Route path='schedule/trainerWorkPlans' element={<SuspensedView><TrainerWrapper /></SuspensedView>} />
        <Route path='schedule/studentPlans' element={<SuspensedView><StudentWrapper /></SuspensedView>} />

        <Route path='report/*' element={<SuspensedView><ReportWrapper></ReportWrapper></SuspensedView>} />


        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return (
    <Suspense fallback={<TopBarProgress />}>
      <DisableSidebar>{children}</DisableSidebar>
    </Suspense>
  )
}

export { PrivateRoutes }
